<app-collapsible-section
  title="Platform"
  [isExpanded]="isExpanded"
  [isCompleted]="isCompleted"
  [showDoneButton]="true"
  (toggle)="onPlatformToggle($event)"
  (done)="onPlatformDone()"
>
  <ng-template #sectionContent>
    <div class="error-message" *ngIf="showValidationError">
      <span>Select a platform for your campaign.</span>
    </div>
    <div class="platform-selection">
      <div class="platform-grid">
        <div
          *ngFor="let option of platformOptions; trackBy: trackByPlatformValue"
          class="platform-card"
          [class.selected]="isPlatformSelected(option.value)"
        >
          <div
            class="platform-icon"
            [class.facebook-icon]="option.iconType === 'facebook'"
            [class.google-ads-icon]="option.iconType === 'google'"
          >
            <ng-container [ngSwitch]="option.iconType">
              <svg
                *ngSwitchCase="'email'"
                width="26"
                height="20"
                viewBox="0 0 26 20"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M1.75 3.75C1.75 3.08696 2.01339 2.45107 2.48223 1.98223C2.95107 1.51339 3.58696 1.25 4.25 1.25H21.75C22.413 1.25 23.0489 1.51339 23.5178 1.98223C23.9866 2.45107 24.25 3.08696 24.25 3.75V16.25C24.25 16.913 23.9866 17.5489 23.5178 18.0178C23.0489 18.4866 22.413 18.75 21.75 18.75H4.25C3.58696 18.75 2.95107 18.4866 2.48223 18.0178C2.01339 17.5489 1.75 16.913 1.75 16.25V3.75Z"
                  stroke="#101223"
                  stroke-width="1.75"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M1.75 3.75L13 11.25L24.25 3.75"
                  stroke="#101223"
                  stroke-width="1.75"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <svg
                *ngSwitchCase="'sms'"
                width="30"
                height="30"
                viewBox="0 0 30 30"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  d="M13.75 3.75H26.25V13.75H22.5L17.5 16.25V13.75H13.75V3.75Z"
                  stroke="#101223"
                  stroke-width="1.75"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
                <path
                  d="M18.75 20V25C18.75 25.3315 18.6183 25.6495 18.3839 25.8839C18.1495 26.1183 17.8315 26.25 17.5 26.25H7.5C7.16848 26.25 6.85054 26.1183 6.61612 25.8839C6.3817 25.6495 6.25 25.3315 6.25 25V7.5C6.25 7.16848 6.3817 6.85054 6.61612 6.61612C6.85054 6.3817 7.16848 6.25 7.5 6.25H10M12.5 22.5V22.5125"
                  stroke="#101223"
                  stroke-width="1.75"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
              <img *ngSwitchCase="'facebook'" src="/assets/images/facebook.svg" alt="Facebook" />
              <img *ngSwitchCase="'google'" src="/assets/images/googleads.svg" alt="Google Ads" />
              <svg
                *ngSwitchCase="'mailer'"
                width="24"
                height="24"
                viewBox="0 0 24 24"
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                aria-hidden="true"
              >
                <path
                  d="M10 21V14.5C10 13.5717 9.63125 12.6815 8.97487 12.0251C8.3185 11.3687 7.42826 11 6.5 11M6.5 11C5.57174 11 4.6815 11.3687 4.02513 12.0251C3.36875 12.6815 3 13.5717 3 14.5V21H21V15C21 13.9391 20.5786 12.9217 19.8284 12.1716C19.0783 11.4214 18.0609 11 17 11H6.5ZM12 11V3H16L18 5L16 7H12M6 15H7"
                  stroke="#354052"
                  stroke-width="1.75"
                  stroke-linecap="round"
                  stroke-linejoin="round"
                />
              </svg>
            </ng-container>
          </div>
          <span class="platform-name">{{ option.label }}</span>
          <div class="platform-checkbox">
            <mat-checkbox
              [checked]="isPlatformSelected(option.value)"
              (change)="onPlatformSelectionToggle(option.value, $event.checked)"
            >
            </mat-checkbox>
          </div>
        </div>
      </div>

      <!-- Validation Error Message -->

      <div class="platform-footer">
        <button class="btn btn-primary btn-medium" (click)="onPlatformDone()">Done</button>
      </div>
    </div>
  </ng-template>
</app-collapsible-section>
